import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CompanyComponent } from './company/company.component';
import { ShowCompanyComponent } from './company/show/show-company.component';


const routes: Routes = [{
  path: '',
  // component: AdminComponent,
  children: [
    {
      path: 'company/:parentId',
      component: ShowCompanyComponent,
    },
    {
      path: 'company',
      component: CompanyComponent,
    },
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InternalAdminRoutingModule {
}

export const routedComponents = [
  CompanyComponent,
  ShowCompanyComponent,
];
